// extracted by mini-css-extract-plugin
export var dateLabel = "_34-0";
export var dateLabelError = "_34-1";
export var fullWidth = "_34-2";
export var smaller = "_34-3";